import { createSlice } from "@reduxjs/toolkit";

interface GlobalLayoutState {
  isSideMenuOpen: boolean;
  globalSelectedSite: string;
  calculationV2FeatureFlag: boolean;
  lmeWorkflowFeatureFlag: boolean;
}

// LME ships everywhere except prod EU and prod FE. Realm identified by its
// AWS region (ErgonaAssetsCDK/lib/constants.ts).
const LME_DISABLED_DEPLOYMENTS: Record<string, true> = {
  "prod|eu-west-1": true, // prod EU
  "prod|ap-northeast-1": true, // prod FE
};

// A lookup key, not a === comparison: Terser folds comparisons of these
// build-time placeholders and strips them before KatalWebpackPlugin can
// substitute, hardcoding the flag.
const DEPLOYMENT_KEY = "gamma|us-east-1";

const isLmeWorkflowEnabled = !LME_DISABLED_DEPLOYMENTS[DEPLOYMENT_KEY];

const initialState: GlobalLayoutState = {
  isSideMenuOpen: false,
  globalSelectedSite: "",
  calculationV2FeatureFlag: true,
  lmeWorkflowFeatureFlag: isLmeWorkflowEnabled,
};

const { reducer, actions } = createSlice({
  name: "GlobalLayout",
  initialState,
  reducers: {
    setIsSideMenuOpen: (state, action) => {
      state.isSideMenuOpen = action.payload;
    },
    setGlobalSelectedSite: (state, action) => {
      state.globalSelectedSite = action.payload;
    },
    setCalculationV2FeatureFlag: (state, action) => {
      state.calculationV2FeatureFlag = action.payload;
    },
    setLmeWorkflowFeatureFlag: (state, action) => {
      state.lmeWorkflowFeatureFlag = action.payload;
    },
  },
});

export const {
  setIsSideMenuOpen,
  setGlobalSelectedSite,
  setCalculationV2FeatureFlag,
  setLmeWorkflowFeatureFlag,
} = actions;

export default reducer;
